// This code has been partially generated by an AI.
export const environment = {
  serverUrl: 'https://skilltree.if.canary.if-dev.de/skilltree-api',
  production: true,
  keycloakUrl: undefined,
};
